import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';
import { UserService } from '../../services/user.service';
import { scrollTo } from 'ng2-utils';

import { ContactPage } from '../contact/contact';

@Component({
  selector: 'page-landing',
  templateUrl: 'landing.html',
  styleUrls: [
    // "../../assets/css/style.css",
  ]
})
export class LandingPage implements AfterViewInit {

  db;
  user = {
    name: '',
    email: '',
    password: '',
  };
  error = '';
  resetPassword = false;
  password = '';

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
  ) {
    this.db = firebase.firestore();
    // this.addLink();
    // $('link[rel=stylesheet][href~="foo.com"]').remove();
    this.removeLink('style1');
    this.removeLink('style2');
    this.removeLink('style3');
    this.removeLink('style4');
    this.removeLink('style5');
    this.removeLink('style6');
    this.removeLink('style7');
    this.removeLink('style8');
    this.removeLink('style9');
    this.removeLink('style10');
    this.removeLink('style11');
    this.removeLink('style12');
    this.removeLink('style13');
    this.removeLink('style14');

    firebase.auth().onAuthStateChanged(async (user: any) => {
      if (user && (user.uid || user.$id)) {
        this.goTo('links');
      }
    });

    if (this.getParameterByName('passwordreset')) {
      this.resetPassword = true;
      var head  = document.getElementsByTagName('head')[0];
      var links = ['../../assets/vendor/bootstrap/bootstrap.css',
      '../../assets/vendor/bootstrap-select/dist/css/bootstrap-select.css',
      '../../assets/vendor/bootstrap-mega-menu/css/menu.css',
      '../../assets/fonts/font-awesome/css/fontawesome-all.min.css',
      '../../assets/vendor/WOW-master/css/libs/animate.css',
      '../../assets/vendor/hover.css',
      '../../assets/fonts/icon/font/flaticon.css',
      '../../assets/vendor/fancybox/dist/jquery.fancybox.min.css',
      '../../assets/vendor/jquery-ui/jquery-ui.min.css',
      '../../assets/css/material-kit.css',
      '../../assets/css/style-app.css'];
      links.forEach((link) => {
        var tempLink  = document.createElement('link');
        tempLink.rel  = 'stylesheet';
        tempLink.type = 'text/css';
        tempLink.href = link;
        head.appendChild(tempLink);
      })
    }
  }

  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      if (params['scrollTo']) {
        this.scrollTo(params['scrollTo']);
      }
    });
  }

  removeLink(id) {
    let el = document.getElementById(id);
    if (!el) return;
    el.parentNode.removeChild( el );
  }

  // userLoaded(user) {
  //   if (user && (user.uid || user.$id)) {
  //     this.goTo('links');
  //   }
  // }

  scrollTo(div) {
    let elmnt = document.getElementById(div);
    if (!elmnt) return;
    elmnt.scrollIntoView();
  }

  create(name, email, password) {
    firebase.auth()
    .createUserWithEmailAndPassword(email, password)
    .then((data) => {
      data.sendEmailVerification();
      this.userService.saveUserSettings(true, { plan: 'free' }, data.uid);
      this.userService.setProfile(data.uid, {
        $id: data.uid,
        name: name,
        email: email,
      }).then(() => {
        this.goTo('links');
      });
    })
    .catch((error) => {
      console.log(error.code, error.message);
      this.error = error.message;
    });
  }

  login(email, password) {
    this.userService.login(email, password).then((data) => {
      this.goTo('links');
    }).catch(function(error) {
      console.log(error.code, error.message);
    });
  }

  // addLink() {
  //   this.db.collection("links").add({
  //     first: "Alan",
  //     middle: "Mathison",
  //     last: "Turing",
  //     born: 1912
  //   })
  // }

  newPassword(newPassword) {
    console.log(this.getParameterByName('oobCode'))
    firebase.auth().confirmPasswordReset(this.getParameterByName('oobCode'), newPassword).then(() => {
      this.goTo('login');
    })
    .catch(function(err) {
      // Invalid code
      console.log(err);
      alert(err.message);
    })
  }

  goTo(page) {
    switch(page) {
      case 'links':
        this.router.navigate(['/links']);
        break;
      case 'login':
        this.router.navigate(['/login']);
        location.reload();
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/landing/landing.ts